import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class WareHouseStore {
  wareHouse = [];
  total = 0;
  loading = false;
  rootStore;
  warehouseStatus=[]

  constructor(rootStore) {
    makeObservable(this, {
      wareHouse: observable,
      total: observable,
      loading: observable,
      warehouseStatus:observable,
      loadData: action,
      addData: action,
      getWareHouse: action,
      deleteRecord: action,
      addWarehouse: action,
      getWASLWarehouseStatus:action
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit }) {
    var postData = { companyId: companyId, offset: offset, limit: limit };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=warehouse&a=warehouselist", "postData=" + base64Input);

    this.wareHouse = response?.data?.data?.warehousedata;

    this.total = parseInt(response?.data?.data?.TotalCount);
  }
  async addData(wareHouseDetails) {
    var postData = wareHouseDetails;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=warehouse&a=addwarehouse", "postData=" + base64Input);
    return response.data;
  }

  async deleteRecord({ warehouseId, companyId ,waslWarehouseKey,option}) {
    var postData = { warehouseId: warehouseId, companyId: companyId,option:option,waslWarehouseKey:waslWarehouseKey };
    const base64Input = await base64_encode(JSON.stringify(postData));
    console.log(postData)
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=warehouse&a=deletewarehouseNew",
        "postData=" + base64Input
      );
    return response;
  }
  async getWareHouse({ wid, companyId }) {
    var postData = { id: wid, companyId: companyId, limit: 1, offset: 0 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=warehouse&a=warehouselist", "postData=" + base64Input);

    return response?.data?.data?.warehousedata[0];
  }

  async addWarehouse(warehouse) {
    var postData = warehouse;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=wasl&a=registerWarehouse", "postData=" + base64Input);

    return response.data;
  }
  async getWASLWarehouseStatus(record) {
    var postData = { Id: record.Id, companyId: record.companyId };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=wasl&a=getwarehouseStatus",
        "postData=" + base64Input
      );
      console.log(response)
      console.log(JSON.parse(response?.data?.data))
    if (JSON.parse(response?.data?.data)) {
      this.warehouseStatus = JSON.parse(response?.data?.data);
    }  else {
      this.warehouseStatus = response?.data?.errors[0][0];
      response = "";
    }

    return (response?.data?.data);
  }
}

export default WareHouseStore;
